import { render, staticRenderFns } from "./TicketModalHeader.vue?vue&type=template&id=6eb0bb06&scoped=true&"
import script from "./TicketModalHeader.vue?vue&type=script&lang=js&"
export * from "./TicketModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./TicketModalHeader.vue?vue&type=style&index=0&id=6eb0bb06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb0bb06",
  null
  
)

export default component.exports